interface IDividerProps {}

const Divider = ({}: IDividerProps) => {
  return <hr className="my-5 text-gray-200 dark:text-gray-700" />;
};

export default Divider;
